/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { TicketListRow } from '../../../shared/ticket/TicketListRow'
import { ticketColors } from '../../../shared/theme/ticketColors';
import { hasUnreadSupportReply, type SupportTicketRow } from '../../../shell/support/services/supportTicketsRepo';
import { formatLocalDateTime } from '@shared/vueltoDateTime';
import {
  supportStatusLabel,
  supportStatusTone,
  supportTypeLabel,
} from '../screens/supportPresentation';

type Props = {
  item: SupportTicketRow;
  selected?: boolean;
  showChevron?: boolean;
  onPress: () => void;
};

function mapTone(tone: ReturnType<typeof supportStatusTone>): 'ok' | 'bad' | 'warn' | 'muted' {
  if (tone === 'success') return 'ok';
  if (tone === 'danger') return 'bad';
  if (tone === 'warning') return 'warn';
  return 'muted';
}

export function SupportTicketRowCard({ item, selected = false, showChevron = false, onPress }: Props) {
  const unread = hasUnreadSupportReply(item);
  const statusLabel = unread ? 'Nuevo' : supportStatusLabel(item.status);
  const statusTone = unread ? 'warn' : mapTone(supportStatusTone(item.status));
  const metaParts = [
    formatLocalDateTime(item.created_at),
    item.replied_at ? 'Con respuesta' : null,
  ].filter(Boolean);

  return (
    <TicketListRow
      title={supportTypeLabel(item.ticket_type)}
      subtitle={item.body}
      meta={metaParts.join(' · ')}
      statusLabel={statusLabel}
      statusTone={statusTone}
      onPress={onPress}
      showChevron={showChevron}
      style={
        selected
          ? {
              borderColor: ticketColors.gold,
              borderWidth: 2,
              backgroundColor: ticketColors.brandSoft,
            }
          : undefined
      }
      accessibilityLabel={`${supportTypeLabel(item.ticket_type)}, ${supportStatusLabel(item.status)}`}
    />
  );
}
